export const INVALID_MEDIA_FILE = 'Invalid file type. Use jpg, jpeg, png or webp';